import React, { useState, useEffect } from 'react';
import exchangeService from '../../services/exchangeService';
import { FaUserFriends } from 'react-icons/fa';
import '../../ExchangeProfilePhoto.css';

// 언어교환 프로필 사진은 서버가 /api/exchange/profile/photo/{id} 경로로 서빙하는데,
// 이 경로가 로그인(JWT)을 요구한다(다른 사람 사진도 봐야 하니까 아예 공개로 열어두진 않았다).
// 그런데 일반 <img src="..."> 태그는 커스텀 Authorization 헤더를 실을 수 없어서,
// 그냥 src에 넣으면 401이 나서 사진이 안 뜬다. 그래서 axios(인증 헤더 포함)로 이미지를
// blob으로 받아온 다음, 브라우저 메모리 안에서만 유효한 임시 URL(objectURL)로 바꿔서 보여준다.
//
// photoUrl이 없으면(사진을 등록 안 한 사용자) 그냥 사람 아이콘 placeholder를 보여준다.
const ExchangeProfilePhoto = ({ photoUrl, size = 48, alt = '프로필 사진' }) => {
  const [objectUrl, setObjectUrl] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let currentObjectUrl = '';
    let cancelled = false;

    setFailed(false);
    setObjectUrl('');

    if (!photoUrl) {
      return undefined;
    }

    exchangeService
      .getProfilePhotoBlob(photoUrl)
      .then((response) => {
        if (cancelled) return;
        currentObjectUrl = URL.createObjectURL(response.data);
        setObjectUrl(currentObjectUrl);
      })
      .catch((err) => {
        console.error('프로필 사진 조회 오류:', err);
        if (!cancelled) setFailed(true);
      });

    // 컴포넌트가 사라지거나 photoUrl이 바뀌면, 만들어뒀던 objectURL을 반드시 해제해야
    // 브라우저 메모리에 계속 쌓이지 않는다.
    return () => {
      cancelled = true;
      if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
    };
  }, [photoUrl]);

  const dimensionStyle = { width: size, height: size };

  if (!photoUrl || failed) {
    return (
      <div className="exchange-profile-photo-fallback" style={dimensionStyle}>
        <FaUserFriends style={{ fontSize: Math.round(size * 0.55) }} />
      </div>
    );
  }

  if (!objectUrl) {
    // 아직 로딩 중이다. 레이아웃이 덜컹거리지 않도록 같은 크기의 빈 placeholder를 보여준다.
    return <div className="exchange-profile-photo-fallback" style={dimensionStyle} />;
  }

  return (
    <img
      src={objectUrl}
      alt={alt}
      className="exchange-profile-photo-img"
      style={dimensionStyle}
    />
  );
};

export default ExchangeProfilePhoto;
